module.exports = require("./pt-GW.d.ts");